//import { table } from 'console';
import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import LoadingBox from '../../Component/LoadingBox';
import MessageBox from '../../Component/MessageBox';
import { listOrderMine } from '../../redux/actions/orderAction';
import { useNavigate } from 'react-router';

export default function OrderHistoryScreen() {
  const orderMineList = useSelector(state => state.orderMineList);

  const { loading, error, orders } = orderMineList;
  // console.log('orderMineList: ' + JSON.stringify(orderMineList));

  const navegate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(listOrderMine());
  }, [dispatch]);

  return (
    <div>
      <h1>Order History</h1>
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>DATE</th>
              <th>TOTAL</th>
              <th>PAID</th>
              <th>DELIVERED</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order._id}>
                <td>{order._id}</td>
                <td>{order.createdAt.substring(0, 10)}</td>
                <td>{order.totalPrice.toFixed(2)}</td>
                <td>{order.isPaid ? order.paidAt.substring(0, 10) : 'No'}</td>
                <td>
                  {order.isDelivered
                    ? order.deliveredAt.substring(0, 10)
                    : 'No'}
                </td>
                <td>
                  <button
                    type="button"
                    className="small"
                    onClick={navegate(`/order/${order._id}`)}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
